import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { PaintTeaserCard } from '@/components/home/PaintTeaserCard';
import { SectionHeading } from '@/components/home/helpers';
import { ArrowRight, Palette } from 'lucide-react';

export const PaintTeaserSection = ({ paints, loading }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section
      className="bg-white dark:bg-slate-900 border-b border-slate-200 dark:border-slate-800"
      data-testid="paint-teaser-strip"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14">
        <SectionHeading
          label={t('home.paints.label')}
          title={t('home.paints.title')}
          subtitle={t('home.paints.subtitle')}
          accentColor="#C026D3"
          testId="paints-heading"
          cta={
            <Button
              variant="outline"
              onClick={() => navigate('/listings?vertical=paints')}
              data-testid="see-all-paints-btn"
              className="rounded-none border-fuchsia-700 text-fuchsia-700 hover:bg-fuchsia-700 hover:text-white gap-2"
            >
              {t('home.paints.seeAll')}
              <ArrowRight className="h-4 w-4" />
            </Button>
          }
        />
        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            {[...Array(3)].map((_, i) => (
              <Skeleton key={i} className="h-28 rounded-none" />
            ))}
          </div>
        ) : paints.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            {paints.map((p) => (
              <PaintTeaserCard key={p.listing_id} listing={p} />
            ))}
          </div>
        ) : (
          <div className="border border-dashed border-fuchsia-200 dark:border-fuchsia-800/40 p-10 text-center bg-fuchsia-50/30 dark:bg-fuchsia-950/20">
            <Palette className="h-10 w-10 mx-auto text-fuchsia-300 dark:text-fuchsia-700 mb-3" />
            <p className="text-sm text-slate-600 dark:text-slate-400">
              {t('home.paints.emptyDesc')}{' '}
              <button
                className="text-fuchsia-700 dark:text-fuchsia-400 font-semibold underline underline-offset-2"
                onClick={() => navigate('/listing/new?vertical=paints')}
                data-testid="empty-paints-create-btn"
              >
                {t('home.paints.emptyCreate')}
              </button>
            </p>
          </div>
        )}
      </div>
    </section>
  );
};
